function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-radius: ", ";\n    cursor: pointer;\n    flex-shrink: 0;\n    padding: ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: unset;\n  text-decoration: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from "react";
import styled, { css } from "styled-components";
import { SmallText } from "@cf-design-system/typography";
var A = styled.a(_templateObject());
var TextEl = styled(SmallText)((_ref) => {
  var {
    theme
  } = _ref;
  return css(_templateObject2(), theme.colors.grey.grey25, theme.spaceUnit.xxs, theme.spaceUnit.xs);
});

var Link = (_ref2) => {
  var {
    children,
    className,
    href
  } = _ref2,
      props = _objectWithoutProperties(_ref2, ["children", "className", "href"]);

  var content = /*#__PURE__*/React.createElement(TextEl, _extends({
    className: !!href ? undefined : className
  }, props), children);
  return !!href ? /*#__PURE__*/React.createElement(A, {
    className: className,
    href: href,
    target: "_blank"
  }, content) : content;
};

export default Link;